import { AnyAction } from "redux";
import { initialState } from "../store/initialState";
import { actionTypeKeys } from "../actions/actionTypeKeys";

export default function closeAppAfterApptReducer(
  state: boolean = initialState.closeAppAfterAppt,
  action: AnyAction
): boolean {
  switch (action.type) {
    case actionTypeKeys.CLOSE_APP_AFTER_APPT:
      return true;
    default:
      return state;
  }
}
